import { DEFAULT_METADATA } from '@/defaultMetadata';

/**
 * Organisation identity config — read from environment variables with
 * hardcoded fallbacks, exactly the same way getDomain() reads CLIENT_URL.
 *
 * Set these in your .env / ECS task environment to override the defaults:
 *
 *   ORG_LEGAL_NAME           (default: see DEFAULT_METADATA.orgLegalName)
 *   ORG_FOUNDING_DATE        (default: see DEFAULT_METADATA.orgFoundingDate)
 *   ORG_EMAIL
 *   ORG_DESCRIPTION          (default: see DEFAULT_METADATA.orgDescription)
 *   ORG_ADDRESS_LOCALITY     (default: see DEFAULT_METADATA.orgAddressLocality)
 *   ORG_ADDRESS_REGION       (default: see DEFAULT_METADATA.orgAddressRegion)
 *   ORG_ADDRESS_COUNTRY      (default: see DEFAULT_METADATA.orgAddressCountry)
 *   ORG_STREET_ADDRESS
 *   ORG_POSTAL_CODE
 */
export function getOrgConfig() {
  return {
    legalName: process.env.ORG_LEGAL_NAME || DEFAULT_METADATA.orgLegalName,
    foundingDate: process.env.ORG_FOUNDING_DATE || DEFAULT_METADATA.orgFoundingDate,
    email: process.env.ORG_EMAIL || null,
    description: process.env.ORG_DESCRIPTION || DEFAULT_METADATA.orgDescription,
    addressLocality: process.env.ORG_ADDRESS_LOCALITY || DEFAULT_METADATA.orgAddressLocality,
    addressRegion: process.env.ORG_ADDRESS_REGION || DEFAULT_METADATA.orgAddressRegion,
    addressCountry: process.env.ORG_ADDRESS_COUNTRY || DEFAULT_METADATA.orgAddressCountry,
    streetAddress: process.env.ORG_STREET_ADDRESS || null,
    postalCode: process.env.ORG_POSTAL_CODE || null,
  };
}
